import React, { Fragment,useState,useEffect } from "react";
import "../../styles/common.css";
import { Outlet } from "react-router-dom";
import TopMenu from "./case-manager-top-menu.jsx";
import logo from "../../assets/images/logo.png";
import {  useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import { catchError } from '../helpers/catch-error'


const Layout = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
 useEffect(() => {
        document.title = "MedRecAps: Case Manager";
        if(!(localStorage.getItem('@user_email') && localStorage.getItem('@user_role') && localStorage.getItem('@user_role')==3) )
            {
             localStorage.removeItem("@first_name");
             localStorage.removeItem("@last_name");
             localStorage.removeItem("@user_role");
             localStorage.removeItem("@user_email");
             navigate("/login");
            }

     }, []);
    const handleLogout = async () => {

        await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/logout", {
            email: localStorage.getItem('@user_email')
        })
            .then(function (response) {
                setIsBtn(false)
                if (response?.data?.status) {

                    localStorage.removeItem("@case_manager_first_name");
                    localStorage.removeItem("@user_role");
                    localStorage.removeItem("@user_email");
                    navigate("/login");


                } else {

                 
                    Swal.fire({ icon: "error", title: "Logout Failed", text: response?.data?.message });

                }
            })
            .catch(function (error) {
                setIsBtn(false)

                catchError(error,navigate)
            });


    };


    return (
        <Fragment>
          
            <section className="top" id="top">
                    <div className="row" >
                        <div className="col" >
                            <img src={logo} alt="MedRecAps" className="top-logo" />
                        </div>
                        <div className="col text-end">
                            <span>{localStorage.getItem("@first_name")} </span>| Case Manager | <a href='#' onClick={() => handleLogout()} className="text-primary fw-bold">{isBtn ? <span><Loading /> Logging Out</span> : 'Logout'}</a>
                        </div>
                    </div>
            </section>  
            <section className="top-menu">          
                        
                   
                            <TopMenu />
                       
                </section>
                <section className="main container-fluid mb-5 ">
                    <Outlet />
                </section>
            
        </Fragment>
    );
};

export default Layout;
